export default {
    type: 'Search agent',
    title: {
        label: 'Name',
        error: 'Please enter a title for the search agent'
    },
    info: 'This search agent is part of the work space',
    button: {
        abort: 'Close',
        submit: 'Save'
    }
}
